    <div class="only-owners">
        <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                     [onlyClient]="true"
                                                     class="margin-bottom-50">
        </app-header-invitation-b2b-partnership-logos>
        <div class="only-owners__description"
             [innerHtml]="
            '$client$ souhaite vous ajouter en tant que partenaire' | transloco: {
            client: invitation.account.organization_name
            }">
        </div>
        <mat-card class="only-owners__card card">
            <mat-card-content>
                <div class="block-content">
                    <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                                 class="margin-bottom-20">
                    </app-header-invitation-b2b-partnership-logos>
                    <div class="block-content__title text-center margin-bottom-20">
                        <span class="block-content__icon icon icon-warning warning icon-size-25"></span>
                        <strong>{{'Vous ne pouvez pas repondre a cette invitation !' | transloco}}</strong>
                    </div>
                    <div class="block-content__text text-center">
                        <div class="margin-bottom-20">
                            <strong>{{'Vous ne disposez pas des droits suffisants pour accepter ou refuser cette invitation.' | transloco}}</strong>
                        </div>
                        <div class="margin-bottom-20"
                             [innerHtml]="'Seuls <strong>les personnes ayant recu directement l\'e-mail d\'invitation</strong> a savoir le/les Responsable(s) legal de $orga$ sont autorises a traiter cette demande.' | transloco : {
                                orga: invitation.extras?.partner?.name
                            }">
                        </div>
                        <div class="margin-bottom-40">
                            {{'Si besoin vous pouvez lui renvoyer cette invitation en cliquant sur le lien ci-dessous :' | transloco}}
                        </div>
                    </div>
                    <div class="
                    block-content__buttons
                    text-center">
                        <a mat-raised-button
                           color="primary"
                           (click)="resendInvitation()"
                           [buttonLoader]="loading">
                            {{ ('Envoyer cette invitation au responsable legal' | transloco) }}
                        </a>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
